import styled from "@emotion/styled"
import { PButtonPure } from "@porsche-design-system/components-react"
import { colorError } from "@porsche-design-system/components-react/emotion"
import type { MouseEvent } from "react"

interface BellIconProps {
	count?: number
	slot?: "button"

	onClick?: (e: MouseEvent<HTMLElement>) => void
}

export const BellIconButton = ({ count, onClick, slot }: BellIconProps) => {
	return (
		<PButtonPure data-testid="notification-bell-button" icon="bell" hideLabel slot={slot} onClick={onClick}>
			{count != null && count > 0 && <RedCircle>{count > 9 ? "9+" : count}</RedCircle>}
		</PButtonPure>
	)
}

const RedCircle = styled.span`
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 13px;
	height: 13px;
	padding: 0 2px;
	box-sizing: border-box;
	position: absolute;
	top: 3px;
	inset-inline-end: 0;
	background: ${colorError};
	border-radius: calc(infinity * 1px);
	color: #fff;
	font-size: 8px;
	text-indent: 0;
`
